import { MainTagProps, MainTagsProps } from "../ProductList.types";
import clsx from "clsx";
import * as React from "react";

const MainTags: React.FC<MainTagsProps> = (props) => {
    return (
        <div className="tmp-product-list__main-tags">
            {props.showAllText ? (
                <div
                    className={clsx("tmp-product-list__main-tags__item", {
                        "tmp-active": !props.selected_tags.length,
                    })}
                    onClick={() => {
                        props.viewAllMainTags();
                    }}
                >
                    <span>{props.showAllText}</span>
                </div>
            ) : (
                ""
            )}

            {props.tags_raw
                .filter((tag) => props.settings?.main_tags.includes(tag.id))
                .sort((a, b) => {
                    if (a.name > b.name) {
                        return 1;
                    }
                    if (a.name < b.name) {
                        return -1;
                    }
                    return 0;
                })
                .map((tag) => (
                    <MainTag
                        key={tag.id}
                        tag={tag}
                        selected_tags={props.selected_tags}
                        onMainTagClick={props.onMainTagClick}
                    />
                ))}
        </div>
    );
};

const MainTag: React.FC<MainTagProps> = (props) => {
    return (
        <div
            className={clsx("tmp-product-list__main-tags__item", {
                "tmp-active": props.selected_tags.includes(props.tag.id),
            })}
            onClick={() => {
                props.onMainTagClick(props.tag);
            }}
        >
            <span>{props.tag.name}</span>
        </div>
    );
};

export default MainTags;
